import React from 'react'

function HorizontalScroller({children ,className = ""
}) {
  return (
    <div className={`horizontal_scroller ${className}`}>
        {children}
    </div>
  )
}

export default HorizontalScroller
